import * as React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { TNativeAccordion } from './NativeAccordion.types';
import './NativeAccordion.styles.scss';
import classNames from 'classnames';

export const NativeAccordion: TNativeAccordion = ({
  title,
  titleIcon,
  children,
}) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const contentRef = React.useRef<HTMLDivElement>(null);

  const contentMaxHeight = isExpanded
    ? `${contentRef.current?.scrollHeight ?? 0}px`
    : '0px';

  const handleToggle = () => {
    setIsExpanded((currentState) => !currentState);
  };

  return (
    <div className="native-accordion">
      <div
        className={classNames('native-accordion__summary', {
          'native-accordion__summary--expanded': isExpanded,
        })}
        role="button"
        tabIndex={0}
        onClick={handleToggle}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleToggle();
          }
        }}
      >
        {typeof title === 'string' ? (
          <div className="native-accordion__summary__regular-title">
            {titleIcon && (
              <div className="native-accordion__summary__regular-title__title-icon">
                {titleIcon}
              </div>
            )}
            <h6 className="native-accordion__title">{title}</h6>
            <ExpandMoreIcon
              className={classNames('native-accordion__expand-icon', {
                'native-accordion__expand-icon--expanded': isExpanded,
              })}
            />
          </div>
        ) : (
          title
        )}
      </div>
      <div
        className="native-accordion__content"
        ref={contentRef}
        style={{
          maxHeight: contentMaxHeight,
          transition: `max-height 250ms ease`,
        }}
      >
        {children}
      </div>
    </div>
  );
};
